




































































































import Vue from 'vue'
import { Element } from 'svg.js'
import store from '@/store'
import tile from '@/components/project-tile.vue'
import borderButton from '@/components/border-button.vue'

export default Vue.extend({
  components: { tile, 'border-button': borderButton },
  data() {
    return {
      blockSize: store.state.isMobile ? window.innerWidth / 4 : 160,
      windowWidth: 0,
      windowHeight: 0,
      showProject: ''
    }
  },
  methods: {
    setWindowSize() {
      this.windowWidth = window.innerWidth
      this.windowHeight = window.innerHeight
    },
    getEventType() {
      const userAgent = navigator.userAgent
      if (userAgent.indexOf('iPhone') >= 0 || userAgent.indexOf('iPad') >= 0 || userAgent.indexOf('Android') >= 0) {
        return 'orientationchange'
      } else {
        return 'resize'
      }
    }
  },

  mounted() {
    this.setWindowSize()

    let timer: number
    window.addEventListener(this.getEventType(), () => {
      if (!timer) clearTimeout(timer)
      timer = setTimeout(() => this.setWindowSize(), 100)
    })
  },

  computed: {
    tileNum(): number {
      const row = Math.floor(this.windowWidth / this.blockSize)
      const col = Math.floor(this.windowHeight / this.blockSize)
      return row * col
    }
  }
})
